import pathnames from "routes/pathnames";
import AppDashboardIcon from "components/icons/app-dashboard-icon";
import AppSetupIcon from "components/icons/app-setup-icon";
import AppUserManagementIcon from "components/icons/app-user-management-icon";
import AppCompanyBenefitsIcon from "components/icons/app-company-benefits-icon";
import AppLeaveManagementIcon from "components/icons/app-leave-management-icon";
import AppClaimManagementIcon from "components/icons/app-claim-management-icon";
import AppCoachingIcon from "components/icons/app-coaching-icon";
import AppELearningIcon from "components/icons/app-e-learning-icon";
import AppOvertimeIcon from "components/icons/app-overtime-icon";


import ROLES from "./roles";

const sideNavList = [
	{
		label: "Setup",
		path: pathnames.setup.setup,
		icon: AppSetupIcon,
		names: null,
		childrens: [],
		relatives: [{ title: "Back to setup", path: pathnames.setup.setupCoverages }],
	},
	{
		label: "Dashboard",
		path: pathnames.dashboard,
		icon: AppDashboardIcon,
		names: null,
		childrens: [],
		relatives: [],
	},
	{
		label: "User Management",
		path: pathnames.userManagement.employees,
		icon: AppUserManagementIcon,
		names: null,
		childrens: [
			{
				label: "Employee",
				path: pathnames.userManagement.employees,
				name: "",
				relatives: [pathnames.userManagement.employee],
			},
			{
				label: "Admin List",
				path: pathnames.userManagement.admins,
				name: ROLES.OWNER,
				relatives: [],
			},
		],
		relatives: [],
	},
	{
		label: "Company Benefits",
		path: pathnames.companyBenefits.positions,
		icon: AppCompanyBenefitsIcon,
		names: null,
		childrens: [
			{
				label: "Job Position",
				path: pathnames.companyBenefits.positions,
				name: "",
				relatives: [],
			},
			{
				label: "Benefit Package",
				path: pathnames.companyBenefits.benefits,
				name: "",
				relatives: [pathnames.companyBenefits.benefit],
			},
		],
		relatives: [],
	},
	{
		label: "Leave Management",
		path: pathnames.leaveManagement.leaves,
		icon: AppLeaveManagementIcon,
		names: null,
		relatives: [],
		childrens: [
			{
				label: "Leave Calendar",
				path: pathnames.leaveManagement.leaves,
				name: "",
				relatives: [],
			},
			{
				label: "Holiday Calendar",
				path: pathnames.leaveManagement.holidayCalendars,
				name: "",
				relatives: [pathnames.leaveManagement.holidayCalendar],
			},
			{
				label: "Leave Directory",
				path: pathnames.leaveManagement.leaveDirectory,
				name: "",
				relatives: [pathnames.leaveManagement.leave],
			},
			{
				label: "Pending Approval",
				path: pathnames.leaveManagement.leavesApproval,
				name: "",
				relatives: [],
			},
			{
				label: "Leave History",
				path: pathnames.leaveManagement.allLeave,
				name: "",
				relatives: [],
			},
		],
	},
	{
		label: "Allowance Management",
		path: pathnames.claimManagement.claimDirectory,
		icon: AppClaimManagementIcon,
		names: null,
		relatives: [],
		childrens: [
			{
				label: "Allowance Directory",
				path: pathnames.claimManagement.claimDirectory,
				name: "",
				relatives: [pathnames.claimManagement.claim],
			},
			{
				label: "Pending Approval",
				path: pathnames.claimManagement.claimApproval,
				name: "",
				relatives: [],
			},
			{
				label: "Claim History",
				path: pathnames.claimManagement.companyClaimHistory,
				name: "",
				relatives: [],
			},
		],
	},
	{
		label: "Overtime Management",
		path: pathnames.overtimeManagement.overtimeApproval,
		icon: AppOvertimeIcon,
		names: null,
		relatives: [],
		childrens: [
			{
				label: "Pending Approval",
				path: pathnames.overtimeManagement.overtimeApproval,
				name: "",
				relatives: [],
			},
			{
				label: "Overtime History",
				path: pathnames.overtimeManagement.overtimeHistory,
				name: "",
				relatives: [],
			},
		],
	},
	{
		label: "Appointment Management",
		path: pathnames.appointmentSession.pageAppointmentSession,
		icon: AppCoachingIcon,
		names: null,
		relatives: [],
		childrens: [
			{
				label: "Appointment List",
				path: pathnames.appointmentSession.pageAppointmentSession,
				name: "",
				relatives: [],
			},
		],
	},
	{
		label: "E-Learning",
		path: pathnames.eLearning.course,
		icon: AppELearningIcon,
		names: null,
		relatives: [],
		childrens: [
			{
				label: "Course",
				path: pathnames.eLearning.course,
				name: "",
				relatives: [],
			},
			{
				label: "Reminder Template",
				path: pathnames.eLearning.reminderTemplate,
				name: "",
				relatives: [],
			},
			{
				label: "Ongoing Assignment",
				path: pathnames.eLearning.ongoingAssignment,
				name: "",
				relatives: [],
			},
			{
				label: "Certificate",
				path: pathnames.eLearning.certificate,
				name: "",
				relatives: [],
			},
			{
				label: "Assignment History",
				path: pathnames.eLearning.assignment,
				name: "",
				relatives: [],
			}
		]
 	}
];

export default sideNavList;
